<template>
    <div class="animated fadeIn">
        <spinner v-if="loading"/>
      <b-card>
          <div slot="header">
              <strong>Search SAN</strong>
            </div>
            <b-row>
                <b-col sm="2">
                    <b-form-group>
                        <label for="san_num">SAN No</label>
                            <b-form-input type="text" id="wto_num" v-model="filter.san_num"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="2">
                    <b-form-group>
                        <label for="country_id">Country</label>
                        <countryLookup v-bind:url="apiCountryLookup" v-on:selected="setCountry($event)" :lookupId="filter.country_id"/>
                    </b-form-group>
                </b-col>    
                <b-col sm="2">
                    <b-form-group>
                        <label for="date_start">Date Start</label>
                            <b-form-input type="date" v-model="filter.date_start"></b-form-input>
                    </b-form-group>
                  </b-col>
                <b-col sm="2">
                    <b-form-group>
                        <label for="date_end">Date End</label>
                            <b-form-input type="date" v-model="filter.date_end"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group>
                        <label for="status">Status</label>
                            <b-form-select id="status" v-model="filter.status"
                                  :plain="true"
                                  :options="['','NEW', 'APPROVED', 'REJECTED']"
                                  value="">
                            </b-form-select>
                  </b-form-group>
                </b-col>     
                <b-col sm="2">
                    <b-form-group>
                          <label for="reson">Reason</label>
                              <b-form-select id="reason" v-model="filter.reason"
                                    :plain="true"
                                    :options="reasonsList"
                                    value="">
                              </b-form-select>
                    </b-form-group>
                  </b-col>                         
            </b-row>
            <div slot="footer">
                <b-button type="submit" size="lg" variant="primary" @click="search">Search</b-button>
                &nbsp;&nbsp;
                <b-button type="submit" size="lg" variant="success" @click="newSAN">New Stock Adjustment Note</b-button>
            </div>
      </b-card>
      <b-row v-if="getRowCount(searchResults) > 0 && !loading">
          <b-col sm="12" >
            <b-card>
                <div slot="header">
                    <strong>Search Results</strong>
                </div>
                <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :current-page="currentPage" 
                :per-page="perPage" :items="searchResults" @row-clicked="rowClick">
                </b-table>
              <nav>
                <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
              </nav>
              <div slot="footer">
                <exportExcel class   = "btn btn-primary btn-lg" size ="lg" :data   = "searchResults" :fields = "exportHeaders" name = "san.xls">
                  Export to Excel
                </exportExcel>
                &nbsp;
                <b-button type="submit" size="lg" variant="success" @click="print">Print</b-button>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-else-if="noResults" >
              <b-col sm="12">
                <div align="center">
                  <strong>No SAN Found</strong>
                </div>                    
              </b-col>
        </b-row>
    </div>
</template>
<script>
import axios from 'axios'
import spinner from '@/components/Spinner.vue'
import countryLookup from '@/components/Autocomplete.vue'
import {authHeader, apiCountryLookup} from '@/functions/common.vue'
import {apiSanSearch} from '@/functions/common.vue'
import exportExcel from 'vue-json-excel' 
import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  pdfMake.fonts = {
      "ukai": {
         normal: 'ukai.ttf',
          bold: 'ukai.ttf',
          italics: 'ukai.ttf',
           bolditalics: 'ukai.ttf'
      },
   };

export default
{
  components:{spinner,countryLookup,exportExcel},
  props: {
      caption: 
      {
        type: String,
        default: 'Table'
      },
      hover: 
      {
        type: Boolean,
        default: false
      },
      striped: 
      {
        type: Boolean,
        default: false
      },
      bordered: 
      {
        type: Boolean,
        default: false
      },
      small: 
      {
        type: Boolean,
        default: false
      },
      fixed: 
      {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        apiCountryLookup:apiCountryLookup,
        loading: false,
        noResults: false,
        filter: 
          {
            san_num: '',
            country_id: '',
            date_start: '',
            date_end: '',
            reason:'',
            status:''
          },  
        searchResults: [],
        searchResultsFields: 
        [
          {key: 'country_id', label: 'Country Code'},
          {key: 'location_id' ,label: 'Location'},
          {key: 'san_date' ,label: 'SAN Date'},
          {key: 'san_num' ,label: 'SAN No'},
          {key: 'reason' ,label: 'Reason'},
          {key: 'reference_num',label: 'Reference No'},
          {key: 'status' ,label: 'Status'},
          {key: 'rejection_reason',label: 'Rejection Reason'},
          {key: 'author_user_shortname' ,label: 'Created By'},
          {key: 'approver_user_shortname' ,label: 'Approver'},
          {key: 'approved_date' ,label: 'Aproved Date'},
        ],
        currentPage: 1,
        perPage: 20,
        totalRows: 0,
        noResults: false,
        exportHeaders:
        {
          'SAN No': 'san_num',
          'Date': 'san_date',
          'Country': 'country_id',
          'Location': 'location_id',
          'Reason':'reason',
          'Reference #':'reference_num',
          'Status':'status',
          'Rejection Reason':'rejection_reason',
          'Created By':'author_user_shortname',
          'Approver':'approver_user_shortname',
          'Approved Date':'approved_date',
        },
      }
    },
    computed:
    {
      reasonsList: function() {
            var list = []

            list.push('')
            list.push('CONVERSION')
            list.push('STOCK COUNT VARIANCE')
            list.push('SHIPMENT DISCREPANCY')
            list.push('GRB / WRITE-OFF ITEM')
            list.push('RECEIVING ERROR BY STAFF')
            list.push('OTHERS')

            return list
        }

    },
    methods: 
    {
      print()
      {
            var rows = []
            var row = []
            var date = new Date()
            rows.push([
            'SAN No',
            'Date',
            'Country',
            'Location',
            'Reason',
            'Status',
            'Rejection Reason',
            'Reference #',
            'Created By',
            'Approver',
            'Approved Date'
            ])

            for (let key in this.searchResults)
            {
              var data = this.searchResults[key]
              var ref = '-'
              if(data.reference_num != '')
              {
                ref = data.reference_num
              }
              row = [
                data.san_num, 
                data.san_date,
                data.country_id,
                data.location_id,
                data.reason,
                data.status,
                data.rejection_reason,
                ref,
                data.author_user_shortname,
                data.approver_user_shortname,
                data.approved_date
                ]
              rows.push(row)
            }
            var dd = {
              header:{ text: 'Stock Adjustment Listing generated on'+ " "+ date, margin: [ 5, 10, 10, 30 ],alignment: 'center',fontSize:9},
              pageSize: 'A4',
              pageOrientation: 'landscape',
            
              // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
              pageMargins: [30, 30, 30, 20 ],
              defaultStyle: {
                    font: 'ukai'
                  },

              content: [
                {
                  fontSize: 10,
                  layout: 'lightHorizontalLines', // optional
                  table: 
                  {
                    // headers are automatically repeated if the table spans over multiple pages
                    // you can declare how many rows should be treated as headers
                    headerRows: 1,
                    widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto' ,'auto','auto','auto'],
                    body: 
                      rows
                  }
                }
              ]
            };

            pdfMake.createPdf(dd).open();
      },
      rowClick(item, index)
        { 
            this.$router.push({ name: 'Stock Adjustment Note Entry (SAN)', params: { sanNum: item.san_num }}) 
        },
      getRowCount (items) 
      {
        return items.length
      },
      search()
      {
        this.loading = true
        var sf =
        [
          "san_num LIKE " + this.filter.san_num
          ,"country_id = " + this.filter.country_id
          ,"san_date >= " + this.filter.date_start
          ,"san_date <= " + this.filter.date_end
          ,"status = " + this.filter.status
          ,"reason = " + this.filter.reason
        ]
        axios.post(apiSanSearch, sf,authHeader())
          .then (res => 
          {
              return res
          })
          .then (data =>
          {
              const resultArray = []
              const myData = data.data.data.list
              for (let key in myData)
              {
                  var date = myData[key].san_date
                  var date = new Date(date);
                  var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                  myData[key].san_date=result
                  var rejection_reason = myData[key].rejection_reason
                  if(rejection_reason == null)
                  {
                    myData[key].rejection_reason = '-'
                  }
                  var r='-'
                  if(myData[key].approved_date != null)
                  {
                    var d = myData[key].approved_date
                     d = new Date(d)
                     r = "" + (d.getDate() > 9 ? '' : '0') + d.getDate() + '/'+  ((d.getMonth() + 1) > 9 ? '' : '0') + (d.getMonth() + 1) + '/' + d.getFullYear()
                  
                  }
                  if(myData[key].approver_user_shortname == null)
                  {
                    myData[key].approver_user_shortname = '-'
                  }
                  myData[key].approved_date=r
                  resultArray.push(myData[key])
                  this.loading = false
              }
              this.searchResults = resultArray
              
              if(this.searchResults.length ==0)
              {
                  this.loading = false
                  this.noResults =true
              }
          })
          .catch(error => 
          {
            this.loading = false
            alert(error) 
          })
      },
      newSAN()
      {
        this.$router.push({ name: 'Stock Adjustment Note Entry (SAN)', params: { sanNum: '_new' }})
      },
      setCountry(obj)
      {
            var id
            if (obj !== null)
            {
              id = obj.id
            } 
            else
            {
              id = null
            }
            this.filter.country_id = id
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/san/sans.vue